import { Component, OnInit } from '@angular/core';
import { BookServiceService } from '../book-service.service';
import { customer } from '../model/customer';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  title = 'House of Book';
  cust:customer;
  constructor(private service:BookServiceService,private router:Router){
    }

  ngOnInit(): void { 
    this.getLoggedInCustomer()
 }
 getLoggedInCustomer() {
  this.service.updatedCustomer.subscribe(customer => this.cust = customer);
  this.cust = JSON.parse(sessionStorage.getItem("customer"));
}


  logOut() {
    sessionStorage.clear();
    this.router.navigate([""])
    this.ngOnInit()
}
}
